export default "__VITE_ASSET__0L4FwVDw__"